import Vue from 'vue'
import { routes } from './router'
import App from './App.vue'
import Element from 'element-ui'
import VueRouter from 'vue-router';
import 'element-ui/lib/theme-chalk/index.css';


Vue.use(Element)
Vue.use(VueRouter)
Vue.config.productionTip = false

const router = new VueRouter({
  routes, // 使用 ES6 的对象解构来传递路由配置
  mode: 'history' // 使用 HTML5 History 模式
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
